import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Square} from './figures/square';
import {Shape} from './figures/shape';
import {Circle} from './figures/circle';
import {Triangle} from './figures/triangle';
import {Heart} from './figures/heart';
import {Star} from './figures/star';
import {BasicModelerRenderer} from './engine/BasicModelerRenderer';
import {Connection} from './figures/connection';
import {AjaxService} from '../../../services/ajax.service';
import {ActivatedRoute} from '@angular/router';
import {Answer} from '../../../dto/answer';
import {Schema} from '../../../dto/schema';
import {Unknownpsy} from './figures/unknownpsy';
import {Platform} from '@angular/cdk/platform';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {DialogBodyComponent} from '../../dialog/dialog-body/dialog-body.component';


@Component({
    selector: 'app-basic-modeler',
    templateUrl: './basic-modeler.component.html',
    styleUrls: ['./basic-modeler.component.css']
})
export class BasicModelerComponent implements OnInit {

    @ViewChild('canvas', {static: true})
    canvas: ElementRef<HTMLCanvasElement>;

    private ctx: CanvasRenderingContext2D;

    private square: Shape = null;
    private circle = null;
    private r: BasicModelerRenderer = null;
    sName = 'PSY';
    // counter: any = 1;
    psychotype = 'KF.AHM1';
    items = [];
    selected1: any = null;
    selected2: any = null;
    schemeName = 'Conflict Scheme';
    schemeType = 'situation';
    savedScheme;
    message;
    sub;
    userId: number;
    signInAlert = '(!Sign In To Save And Upload Conflict Schemes!)';
    signInColor = 'red';
    // uploaded schemes list
    schemes: Schema;
    schemeId = 0;
    flowtype = 'ua.ahm1';
    checkedPsyName = '';
    removeSelectedPSYDisabled = true;
    mouseEventsAvaliable = true;
    psyChecked = false;
    message1 = '';
    flowDescription = '';
    groupsList = [];
    groupsListSelect;
    psychotypeFlows = [];
    psychotypeFlowsSelect;
    flowChecked = '';
    flowCheckedModel;
    deleteFlowEnable = false;
    psychotypesInSchema;
    // add flow group number when new connection uploaded
    // reset with create new schema button
    // ++ for avaliable integer number > 0 for new connection
    flowGroupNumber = [];

    constructor(private ajax: AjaxService, private route: ActivatedRoute, public platform: Platform, private matDialog: MatDialog) {
        // console.log('********************** Platform:: ', platform);
        this.userId = ajax.id;
        if (0 != this.userId) {
            this.signInAlert = '(You Signed In)';
            this.signInColor = 'green';
        }
        let desktopClient = true;
        if (platform.ANDROID || platform.IOS) {
            desktopClient = false;
        }
        if (platform.isBrowser && platform.BLINK) {
            // okay
        }else {
            desktopClient = false;
        }
        if (!desktopClient) {
            this.openDialog('This is Desktop App. Use MacBook, NoteBook, PC or mouse emulator.');
        }
        // set group number field by default values
        this.groupsList.push(1);
        this.groupsListSelect = this.groupsList[0];
    }

    openDialog(text) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = text;
        this.matDialog.open(DialogBodyComponent, dialogConfig);
    }

    ngOnInit(): void {
        // canvas full width
        const screen: any = document.getElementById('screen');
        screen.width = window.innerWidth;
        this.ctx = this.canvas.nativeElement.getContext('2d');
        this.r = new BasicModelerRenderer(this.ctx, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
        // load conflict schemas and put into select
        this.getAllSchema();
    }

    /**
     * uploading all schemes on init and after saving new scheme
     */
    async getAllSchema() {
        this.schemes = await this.ajax.getAllSchema(this.userId);
    }

    uploadedSchema = null;

    /**
     * all schemas uploaded just choose one of them by name
     *
     * @param schemaName
     */
    uploadThisSchema() {
        let schema = null;
        // reset group numbers
        this.groupsList = [];

        schema = this.psychotypeFlowsSelect;

        // console.log('schema >--->', schema);

        this.uploadedSchema = schema;
        // no schema choosen
        if (null != schema) {
            // set values in html temlate [(ngModel)]
            this.schemeName = schema.name;
            this.schemeType = schema.type;
            this.schemeId = schema.id;
            if (null != schema) {
                // console.log('uploadThisSchema', schema);
                const psy = schema.psy + '';
                const tokens = psy.split(';');
                this.r.objects = [];
                this.r.connections = [];
                for (let i in tokens) {
                    if (null != tokens[i] && '' != tokens[i]) {
                        // console.log('**', tokens[i]);
                        const interTokens = tokens[i].split(',');
                        let obj = interTokens[0];
                        let type = interTokens[1];
                        let name = interTokens[2];
                        let x: number = Number(interTokens[3]), y: number = Number(interTokens[4]),
                            z: number = Number(interTokens[5]);
                        let id: string = String(interTokens[6]);
                        if ('shape' === obj) {
                            // create new shape
                            this.r.createShape(type, name, x, y, z, id);
                        }
                    }
                }
                // create connections after psychotypes created
                // // console.log('this.r.connections', tokens);
                for (let i in tokens) {
                    if (null != tokens[i] && '' != tokens[i]) {
                        // console.log('**', tokens[i]);
                        const interTokens = tokens[i].split(',');
                        // console.log('schema >--->', i, tokens[i]);
                        let obj = interTokens[0];
                        let id1: string = String(interTokens[1]);
                        let id2: string = String(interTokens[2]);
                        let type: string = interTokens[3];
                        // optional in old version may not exists
                        let description: string = '';
                        if (interTokens.length > 4) {
                            description = String(interTokens[4]);
                        }
                        //
                        let group: string = '';
                        if (interTokens.length > 5) {
                            group = String(interTokens[5]);
                        }
                        if ('connection' === obj) {
                            // create new connection
                            this.selected1 = this.r.findShapeById(id1);
                            this.selected2 = this.r.findShapeById(id2);
                            if (this.contains.call(this.groupsList, Number(group))) {
                                //console.log('this.contains');
                            }else {
                                //console.log('not this.contains');
                                this.groupsList.push(Number(group));
                            }
                            this.createConnection2PSYUploading(type, true, description, Number(group));
                        }
                        // this.groupsList
                    }
                }
                // set new group into field
                let counter = 0;
                while (-1 != counter) {
                    counter++;
                    if (!this.contains.call(this.groupsList, counter)) {
                        this.groupsList.push(counter);
                        this.groupsListSelect = this.groupsList[this.groupsList.length - 1];
                        counter = -1;
                    }
                }
                this.items = this.r.objects;
                this.r.redrawAllObjects(null);
            }
        }
    }

    contains = function(needle) {
        // Per spec, the way to identify NaN is that it is not equal to itself
        var findNaN = needle !== needle;
        var indexOf;

        if(!findNaN && typeof Array.prototype.indexOf === 'function') {
            indexOf = Array.prototype.indexOf;
        } else {
            indexOf = function(needle) {
                var i = -1, index = -1;

                for(i = 0; i < this.length; i++) {
                    var item = this[i];

                    if((findNaN && item !== item) || item === needle) {
                        index = i;
                        break;
                    }
                }

                return index;
            };
        }

        return indexOf.call(this, needle) > -1;
    };

    /**
     * todo: upload flow data into "SYMPTOM / HEALTH FLOW" section
     */
    symptomHealthFlowSectionUpdate() {
        this.blockMouseEventsForAWhile(3);
        // console.log('-----------------------------> psychotypeFlows', this.psychotypeFlowsSelect);
        if ('select' !== String(this.psychotypeFlowsSelect)) {
            let connection: any = this.psychotypeFlowsSelect;
            this.flowChecked = connection.type;
            this.flowDescription = connection.description;
            this.flowCheckedModel = true;
            this.deleteFlowEnable = true;
            this.selected1 = connection.fromPsycotype;
            this.selected2 = connection.toPsychotype;
            this.flowtype = connection.type;
            if (0 != connection.group) {
                this.groupsListSelect = connection.group;
            }
        }
    }

    deleteSelectedConnection() {
        if ('select' !== String(this.psychotypeFlowsSelect)) {
            let connection: any = this.psychotypeFlowsSelect;
            this.flowChecked = connection.type;
            this.flowCheckedModel = true;
            for (let i in this.r.connections) {
                let conn = this.r.connections[i];
                if (conn.id === connection.id) {
                    for (let j in this.psychotypeFlows) {
                        if (this.psychotypeFlows[j].id === connection.id) {
                            this.psychotypeFlows.splice(Number(j),1);
                            break;
                        }
                    }
                    this.r.connections.splice(Number(i), 1);
                    this.psychotypeFlowsSelect = 'select';
                    this.flowChecked = '';
                    this.flowCheckedModel = false;
                    this.r.redrawAllObjects(null);
                    break;
                }
            }
            this.deleteFlowEnable = false;
        }
    }


    async saveSchemeName() {

        let answer:Answer;
        // returs scheme id
        this.savedScheme = [];
        this.savedScheme = this.r.saveThisScheme(this.schemeName, this.schemeType);
        // console.log('scheme', this.savedScheme, this.r.savedSchemA);

        // console.log('--------------->this.uploadedSchema', this.uploadedSchema);

        if (null == this.uploadedSchema) {
            // no need of return value
            answer = await this.ajax.saveScheme(-1000, -1000, this.r.savedSchemA, this.schemeName, this.schemeType);
        }else {
            // // console.log('------------------->this.uploadedSchema', this.uploadedSchema);
            answer = await this.ajax.saveScheme(this.uploadedSchema.id, -1000, this.r.savedSchemA, this.schemeName, this.schemeType);
        }

        if ('success' === answer.result) {
            this.message = '[scheme saved]';
        } else {
            this.message = '[scheme not saved]';
        }
        // update messages
        setTimeout(() => {
            this.message = '';
        }, 3000);
        this.items = [];

        // upload new list of schemes
        // setTimeout(() => {

        this.getAllSchema();

        // }, 1000);
        // console.log('saveSchemeName', answer);

        this.resetGroups();
    }

    fixLength() {
        // console.log(this.sName);
    }

    newScheme() {
        this.schemeName = 'Conflict Scheme';
        this.schemeType = 'Situation';
        this.items = [];
        this.r.objects = [];
        this.r.connections = [];
        this.schemeId = 0;
        this.savedScheme = [];
        this.uploadedSchema = null;
        this.getAllSchema();
        this.r.redrawAllObjects(null);
        //
        this.resetGroups();
    }

    resetGroups() {
        this.groupsList = [];
        this.groupsList.push(1)
        this.groupsListSelect = 1;
    }

    allConnections() {
        // console.log('allConnections', this.r.connections);
    }

    async deleteThisSchema() {
        // console.log('deleteThisSchema', this.schemeId);
        // // console.log('this.schemes', this.schemes);
        let answer: Answer;

        if (0 != this.schemeId) {
            answer = await this.ajax.removeSchema(this.schemeId, this.userId);
            if (null != answer && 'success' === answer.result) {
                this.message = 'Scheme Removed';
                // update messages
                setTimeout(() => {
                    this.message = '';
                }, 3000);
            }
            this.getAllSchema();
        }else {
            this.openDialog('no schema choosen');
        }

        // this.resetGroups();
    }

    setPsyName() {

        // this.sName = '';
        // this.counter = '';
        // // console.log('setPsyName');
    }

    // todo: draw triangle
    // todo: завернуть фигуры в shape, соединения в connections, рисовальщик в renderer (internal), схему в model
    // the triangle
    // context.beginPath();
    // context.moveTo(100, 100);
    // context.lineTo(100, 300);
    // context.lineTo(300, 300);
    // context.closePath();

    /**
     * acts when clicked on area
     */
    mouseCursorLocation() {
        // // console.log('mouseCursorLocationmouseCursorLocationmouseCursorLocationmouseCursorLocationmouseCursorLocationmouseCursorLocationmouseCursorLocation');
        if (this.mouseEventsAvaliable) {
            // redraw all objects before this one to make it visible
            this.r.redrawAllObjects(this.square);

            // console.log('this.canvas.nativeElement', this.canvas.nativeElement);
            const event: any = window.event;
            // todo: 260 hardcoded but need to find in nativeElement
            // // console.log('mouse location:', event.clientX - this.canvas.nativeElement.offsetLeft,
            //   event.clientY - this.canvas.nativeElement.offsetTop + topOffset, this.canvas);
            if (null != this.square) {
                // todo: refactor and create method for this
                const topOffset = this.getScroll()[1];
                this.square.putThisCoords(event.clientX - this.canvas.nativeElement.offsetLeft, event.clientY - this.canvas.nativeElement.offsetTop + topOffset);
                this.square.drawOnDefPosition();
            }
            // psy control
            if (null != this.square) {
                this.checkedPsyName = this.square.name;
                this.sName = this.square.name;
                this.psyChecked = true;
                this.setPsychotypesFlow();
            }
        }
    }

    mouseCursorOut() {
        this.r.redrawAllObjects(this.square);
    }

    setPsychotypesFlow() {
        // console.log('setPsychotypesFlow'/*, this.square*/);
        // set up all sympthoms and health flows
        this.psychotypeFlows = [];
        for (let i in this.r.connections) {
            let flow: Connection = this.r.connections[i];
            // console.log('flow', flow.toPsychotype.id, flow.fromPsycotype.id);
            if (flow.toPsychotype.id === this.square.id) {
                // console.log('Psychotype flows: ', this.square.id);
                this.psychotypeFlows.push(flow);
            }
            if (flow.fromPsycotype.id === this.square.id) {
                // console.log('Psychotype flows: ', this.square.id);
                this.psychotypeFlows.push(flow);
            }
        }
    }

    /**
     * Find scroll
     *
     * returns [leftOffset, topOffset]
     */
    getScroll = function () {
        if (window.pageYOffset != null) {
            return [pageXOffset, pageYOffset];
        } else {
            let sx, sy;
            const d = document,
                r = d.documentElement,
                b = d.body;
            sx = r.scrollLeft || b.scrollLeft || 0;
            sy = r.scrollTop || b.scrollTop || 0;
            return [sx, sy];
        }
    }

    allShapes() {
        // console.log(this.r.objects);
    }

    newShapeName() {
        // console.log('this s name', this.sName/* + this.counter*/);
        this.square.setName(this.sName/* + this.counter*/);
    }

    // fix element
    fixElementPositionMouse() {
        // todo: and put it into renderer, or model that renderer will redraw every move
        // if (!this.movingAvaliableFlag) {
        const event: any = window.event;
        if (null != this.square) {
            // put here previous shape
            this.r.putNewFigure(this.square);
            this.items = this.r.objects;
            const topOffset = this.getScroll()[1];
            this.square.drawOnPosition(event.clientX - this.canvas.nativeElement.offsetLeft,
                event.clientY - this.canvas.nativeElement.offsetTop + topOffset);
            this.resetSymptomHealthSection();
        }
        this.square = null;
        // this.psychotypeFlowsSelect = null;
        // psy control
        this.checkedPsyName = '';
        this.psyChecked = false;
        this.sName = 'PSY';
    }

    // fix element
    fixElementPositionButton() {
        // todo: and put it into renderer, or model that renderer will redraw every move
        if (null != this.square) {
            this.r.putNewFigure(this.square);
            this.items = this.r.objects;
            // this.square.draw();
            this.r.redrawAllObjects(this.square);
        }
        this.square = null;
        // psy control
        this.checkedPsyName = '';
        this.psyChecked = false;
        this.sName = 'PSY';
    }

    choosePsychotypeInTable(item) {
        this.square = item;
        if (null != this.square) {
            this.checkedPsyName = this.square.name;
            this.sName = this.square.name;
            this.psyChecked = true;
            this.setPsychotypesFlow();
        }
    }

    // block mouse events for a few seconds not to move selected psychotype
    blockMouseEventsForAWhile(seconds){
        this.mouseEventsAvaliable = false;
        setTimeout(() => { this.mouseEventsAvaliable = true; }, seconds * 1000);
    }

    choosePsychotypeInTableOption() {
        this.blockMouseEventsForAWhile(3);
        // console.log('this.psychotypesInSchema', this.psychotypesInSchema);
        // find psy with name+type in array
        for (let i in this.items) {
            const nameInOption = this.items[i].name + ' ' + this.items[i].type;
            const nameFromSelect = this.psychotypesInSchema.name + ' ' + this.psychotypesInSchema.type;
            if (nameFromSelect === nameInOption) {
                this.square = this.items[i];
                this.checkedPsyName = this.square.name;
                this.sName = this.square.name;
                this.psyChecked = true;
                this.setPsychotypesFlow();
            }
        }
        // enable remove psy button
        this.removeSelectedPSYDisabled = false;
        // remove connection information
        this.resetSymptomHealthSection();
    }

    resetSymptomHealthSection() {
        this.flowChecked = '';
        this.flowDescription = '';
        this.flowCheckedModel = false;
        this.deleteFlowEnable = false;
        this.selected1 = null;
        this.selected2 = null;
    }

    removePsychotypeSelected(){
        this.removePsychotype(this.square);
        // disable remove psy button again
        this.removeSelectedPSYDisabled = true;
    }

    saveNewPSYname() {
        this.square.name = this.sName;
        this.checkedPsyName = this.square.name;
        // redraw canvas
        this.r.redrawAllObjects(this.square);
    }

    removePsychotype(item) {

        // // console.log('removePsychotype', item, this.r.connections);

        let connectionsToRemoveIndexesList = [];

        // remove connections "from" this object and "to" this object before removing object
        for (let i in this.r.connections) {
            if (
                this.r.connections[i].psy1.id === item.id ||
                this.r.connections[i].psy2.id === item.id
            ) {
                connectionsToRemoveIndexesList.push(i);
            }
        }
        let counterDeleted = 0;
        for (let j in connectionsToRemoveIndexesList) {
            this.r.connections.splice(connectionsToRemoveIndexesList[j] - counterDeleted, 1);
            counterDeleted ++;
        }
        // // console.log('connectionsToRemoveIndexesList', connectionsToRemoveIndexesList);

        // remove object from renderer

        let idToDelete = item.id;
        let itemInObjectsPosition:any = -1;
        let itemInItemsPosition:any = -1;


        for (let key in this.r.objects) {
            if (idToDelete === this.r.objects[key].id) {
                itemInObjectsPosition = key;
            }
        }

        for (let ikey in this.items) {
            if (idToDelete === this.items[ikey].id) {
                itemInItemsPosition = ikey;
            }
        }

        // // console.log('before', this.r.objects, this.items, itemInItemsPosition, itemInObjectsPosition);

        if (-1 !== itemInObjectsPosition
            && -1 !== itemInItemsPosition) {
            // this arrays are in relation. deleting in one -> make the same in other
            this.items.splice(itemInItemsPosition, 1);
            // this.r.objects.splice(itemInObjectsPosition, 1);
        }

        // // console.log('after', this.r.objects, this.items);

        // this.items = [];

        // remove all connections from renderer

        // delete row in table
        item = null;
        this.square = null;

        // redraw canvas
        this.r.redrawAllObjects(this.square);

        this.checkedPsyName = '';
        this.sName = 'PSY';
        this.psyChecked = false;

    }

    createPSY(): void {
        this.r.redrawAllObjects(this.square);
        if ('DF.AHM1' === this.psychotype) {
            this.square = new Square(this.ctx, this.sName/* + this.counter*/);
        }
        if ('KF.AHM1' === this.psychotype) {
            this.square = new Circle(this.ctx, this.sName/* + this.counter*/);
        }
        if ('AF.AHM1' === this.psychotype) {
            this.square = new Triangle(this.ctx, this.sName/* + this.counter*/);
        }
        if ('THP.AHM1' === this.psychotype) {
            this.square = new Star(this.ctx, this.sName/* + this.counter*/);
        }
        if ('MHP.AHM1' === this.psychotype) {
            this.square = new Heart(this.ctx, this.sName/* + this.counter*/);
        }
        if ('UNKNOWN.AHM1' === this.psychotype) {
            this.square = new Unknownpsy(this.ctx, this.sName/* + this.counter*/);
        }
        // set psy name into psy control
        this.checkedPsyName = this.square.name/* + this.counter*/;
        this.sName = this.square.name;
        this.psyChecked = true;
        this.setPsychotypesFlow();
        // set default name into input
        this.square.draw();
        if ('' === this.sName) {
            this.sName = 'PSY';
            // this.psyChecked = false;
            // this.counter = 0;
        }
        // this.counter++;
    }

    moveRIGHT() {
        if (null != this.square) {
            // redraw all objects before this one to make it visible
            this.r.redrawAllObjects(this.square);
            this.square.moveRight();
        }
    }

    moveLEFT() {
        if (null != this.square) {
            // redraw all objects before this one to make it visible
            this.r.redrawAllObjects(this.square);
            this.square.moveLeft();
        }
    }

    moveUP() {
        if (null != this.square) {
            // this.square.moveUp();
            // redraw all objects before this one to make it visible
            this.r.redrawAllObjects(this.square);
            this.square.moveUp();
        }
    }

    moveDOWN() {
        if (null != this.square) {
            // redraw all objects before this one to make it visible
            this.r.redrawAllObjects(this.square);
            this.square.moveDown();
        }
    }

    animateCircle(): void {
        this.circle = new Circle(this.ctx);
        this.circle.draw();
    }

    moveCircleRIGHT() {
        if (null != this.circle) {
            this.circle.moveRight();
        }
    }

    moveCircleLEFT() {
        if (null != this.circle) {
            this.circle.moveLeft();
        }
    }

    moveCircleUP() {
        if (null != this.circle) {
            this.circle.moveUp();
        }
    }

    moveCircleDOWN() {
        if (null != this.circle) {
            this.circle.moveDown();
        }
    }

    getPsychotypeByCoords() {
        // console.log('getPsychotypeByCoords');
        const event: any = window.event;
        const topOffset = this.getScroll()[1];
        const psychotype = this.r.getPsychotypeByCoords(event.clientX - this.canvas.nativeElement.offsetLeft,
            event.clientY - this.canvas.nativeElement.offsetTop + topOffset);
        if (null != psychotype) {
            this.square = psychotype;
            this.resetSymptomHealthSection();
        }
    }

    /**
     * create connection
     */
    createConnection(psy) {
        // console.log('create connection');
        if (null != psy) {
            if (null == this.selected1) {
                this.selected1 = psy;
            } else if (null == this.selected2) {
                this.selected2 = psy;
                if (this.selected1.id !== this.selected2.id) {
                    const s1 = this.selected1;
                    const s2 = this.selected2;
                    const connection = new Connection(this.ctx, s1, s2);
                    this.r.putNewConnection(connection);
                    this.r.redrawAllObjects(null);
                    this.selected1 = null;
                    this.selected2 = null;
                }
            }
        }
    }

    /**
     *
     */
    createConnection2PSY(type = undefined, noRedraw = false) {
        // console.log('***flowDescription***', this.flowDescription);
        // console.log('createConnection2PSY', this.selected1, this.selected2);

        if (null != this.selected1 && null != this.selected2) {
            if (this.selected1.id !== this.selected2.id) {
                const s1 = this.selected1;
                const s2 = this.selected2;
                // console.log('create new connection', this.flowtype);
                if (null == type) {
                    type = this.flowtype;
                }
                const connection = new Connection(this.ctx, s1, s2, type, this.flowDescription, this.groupsListSelect);
                this.r.putNewConnection(connection);
                if (!noRedraw) {
                    this.r.redrawAllObjects(null);
                }
                this.selected1 = null;
                this.selected2 = null;
                // update group number list
                let counter = 0;
                while (-1 != counter) {
                    counter++;
                    // console.log('counter = ', counter);
                    let containes = 0;
                    for (let group in this.groupsList) {
                        // console.log(Number(this.groupsList[group]));
                        if (Number(this.groupsList[group]) == counter) {
                            containes++;
                        }
                    }
                    if (0 == containes) {
                        this.groupsList.push(counter);
                        this.groupsListSelect = this.groupsList[this.groupsList.length - 1];
                        counter = -1;
                    }
                }
            }
            this.message1 = '[flow created]';
            // this.deleteFlowEnable = true;
        }else {
            this.message1 = '[flow not created]';
        }
        // update messages
        setTimeout(() => {
            this.message1 = '';
        }, 3000);
    }

    createConnection2PSYUploading(type = undefined, noRedraw = false, description, group = 0) {
        // console.log('***flowDescription***', this.flowDescription);
        // console.log('createConnection2PSY', this.selected1, this.selected2);

        if (null != this.selected1 && null != this.selected2) {
            if (this.selected1.id !== this.selected2.id) {
                const s1 = this.selected1;
                const s2 = this.selected2;
                // console.log('create new connection', this.flowtype);
                if (null == type) {
                    type = this.flowtype;
                }
                const connection = new Connection(this.ctx, s1, s2, type, description, group);
                this.r.putNewConnection(connection);
                if (!noRedraw) {
                    this.r.redrawAllObjects(null);
                }
                this.selected1 = null;
                this.selected2 = null;
            }
            this.message1 = '[flow created]';
            // this.deleteFlowEnable = true;
        }else {
            this.message1 = '[flow not created]';
        }
        // update messages
        setTimeout(() => {
            this.message1 = '';
        }, 3000);
    }

}
